import { render, staticRenderFns } from "./identityCloud.vue?vue&type=template&id=5b700bc0&scoped=true"
import script from "./identityCloud.vue?vue&type=script&lang=js"
export * from "./identityCloud.vue?vue&type=script&lang=js"
import style0 from "./identityCloud.vue?vue&type=style&index=0&id=5b700bc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b700bc0",
  null
  
)

export default component.exports